import type { WebChannelAuthConfig } from '@repo/api/web/models'

import { LoginInputType } from '#Auth/components/Form/type'

const LOGIN_TYPE_ORDER = [
  LoginInputType.phone,
  LoginInputType.email,
] as const

export const LOGIN_TYPE_TAB_LABELS: Record<LoginInputType, string> = {
  [LoginInputType.phone]: 'По телефону',
  [LoginInputType.email]: 'По email',
}

export function getAllowedLoginTypes(
  config?: WebChannelAuthConfig,
): LoginInputType[] {
  if (!config) {
    return [LoginInputType.phone]
  }

  return LOGIN_TYPE_ORDER.filter((type) => {
    if (type === LoginInputType.phone) {
      return config.allowPhoneLogin
    }

    return config.allowEmailLogin
  })
}

export function getDefaultLoginType(
  config?: WebChannelAuthConfig,
): LoginInputType {
  const allowedTypes = getAllowedLoginTypes(config)

  if (allowedTypes.includes(LoginInputType.phone)) {
    return LoginInputType.phone
  }

  return allowedTypes[0] ?? LoginInputType.phone
}
